import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {ViewMyServicesRoutingModule} from './view-my-services-routing.module';
import {ViewMyServicesComponent} from './view-my-services.component';
import {BreadcrumbModule} from '../../components/breadcrumb/breadcrumb.module';
import {SharedModule} from '../../shared/shared.module';
import {VerticalMenuModule} from '../../components/vertical-menu/vertical-menu.module';
import {IconsModule} from '../../icons/icons.module';
import {MatSelectModule} from '@angular/material/select';
import {CardModule} from '../service/card/card.module';
import {MyServicesModule} from '../service/my-services/my-services.module';
import {ByobMyServicesModule} from '../../components/byob-my-services/byob-my-services.module';
import {MultiSelectDropdownModule} from '../../components/multi-select-dropdown/multi-select-dropdown.module';
import {DropdownFilterModule} from '../../components/dropdown-fliter/dropdown-filter.module';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import {MatProgressBarModule} from '@angular/material/progress-bar';

@NgModule({
  declarations: [
    ViewMyServicesComponent
  ],
  imports: [
    CommonModule,
    ViewMyServicesRoutingModule,
    BreadcrumbModule,
    SharedModule,
    VerticalMenuModule,
    IconsModule,
    MatSelectModule,
    CardModule,
    MyServicesModule,
    ByobMyServicesModule,
    MultiSelectDropdownModule,
    DropdownFilterModule,
    MatProgressSpinnerModule,
    MatProgressBarModule
  ]
})
export class ViewMyServicesModule { }
